import PropTypes from "prop-types";
import { plpPageConstants } from "../../../constants/pageConstants/plpConstants";

/**
 * PlpTitleRowMobile component renders the mobile version of the title row
 * on a Product Listing Page (PLP). It displays the product category or search query,
 * product count, and optionally a review rating summary.
 *
 * @component
 * @param {Object} props - Component props
 * @param {string} props.productCategoryName - Name of the product category being displayed
 * @param {string} props.searchQuery - Search term entered by the user
 * @param {number} props.totalRenderedProducts - Number of products currently rendered
 * @param {number} props.totalNoOfProducts - Total number of products available
 * @param {number} [props.reviewCount] - Total number of reviews available (optional)
 * @param {number} [props.bestRating] - Best product rating (optional)
 * @param {Function} props.onScrollToReviews - Function triggered to scroll to the reviews section
 *
 * @returns {JSX.Element} A mobile-friendly title row with product info and review rating
 */
const PlpTitleRowMobile = ({
  // isMobile,
  productCategoryName,
  searchQuery,
  totalRenderedProducts,
  totalNoOfProducts,
  // reviewCount,
  // onScrollToReviews,
  // bestRating,
}) => {
  return (
    <>
      <div className={`flex w-full items-center justify-start gap-8`} id="plpCategoryTitle">
        <h1
          className={`overflow-hidden text-ellipsis whitespace-nowrap text-16 font-500 text-black-100 ${productCategoryName ? "font-600" : ""}`}
          itemprop="name"
        >
          {productCategoryName || `${plpPageConstants.SEARCH_RESULTS_FOR} `}
          {searchQuery && <strong>&apos;{searchQuery}&apos;</strong>}
        </h1>
        {totalRenderedProducts && (
          <div className="flex items-center gap-8">
            <span className="h-[4px] w-[4px] rounded-full bg-grey-200" />
            <div className="whitespace-nowrap text-14 font-500 capitalize text-grey-400">{`${totalNoOfProducts} items`}</div>
          </div>
        )}
      </div>
      {/* {reviewCount > 0 && (
        <div className="flex items-center justify-center pb-16">
          <PLPReviewRatings
            isMobile={isMobile}
            bestRating={bestRating}
            reviewCount={reviewCount}
            onScrollToReviews={onScrollToReviews}
          />
        </div>
      )} */}
    </>
  );
};
PlpTitleRowMobile.propTypes = {
  // isMobile: PropTypes.bool.isRequired,
  productCategoryName: PropTypes.string.isRequired,
  searchQuery: PropTypes.string,
  // onScrollToReviews: PropTypes.func.isRequired,
  totalRenderedProducts: PropTypes.number.isRequired,
  totalNoOfProducts: PropTypes.number.isRequired,
  // reviewCount: PropTypes.number,
  // bestRating: PropTypes.number,
};
export default PlpTitleRowMobile;
